module.exports = __webpack_public_path__ + "media/images/metronic/social/spotify-05bf2b069f0fe66738925838ae0b1eb1.png";